<ion-app>
  <ion-split-pane contentId="main-content" when="768">
    <ion-menu contentId="main-content" id="lessorMenuId" class="modern-menu">

      <!-- Header do Menu -->
      <ion-header class="menu-header">
        @if(isPWA()) {
          <div class="menu-header-bg-web"></div>
        } @else {
          <div class="menu-header-bg"></div>
        }

        <div class="header-content" [ngClass]="{ 'header-content-web': isPWA() }">
          <div class="profile-section"
               (click)="redirectMultiAccount()"
               (keypress)="redirectMultiAccount()">
            <!-- Avatar de QUEM está logado: o nome ao lado é o da pessoa, então
                 a foto pessoal vem primeiro. Sem foto (o caso da maioria), cai
                 na logo do centro esportivo e, por fim, no ícone. -->
            <div class="profile-avatar">
              @if (avatarImage(); as avatar) {
                <img [src]="avatar" [alt]="selectResponsavelName() || 'Perfil'" />
              } @else {
                <div class="avatar-placeholder">
                  <ion-icon name="business-outline"></ion-icon>
                </div>
              }
            </div>

            <div class="profile-info">
              @if (selectSportCenterName(); as name) {
                <div class="profile-header">
                  <h2 class="sport-center-name">{{ name | summarizeName }}</h2>
                  @if (hasPermission$([requiredRole.ROLE_COMPANY]) | async) {
                    <ion-button
                      fill="clear"
                      size="small"
                      class="premium-button"
                      (click)="redirectPricingPage()"
                      (keypress)="redirectPricingPage()">
                      <ion-icon name="diamond-outline"></ion-icon>
                    </ion-button>
                  }
                </div>
              }
              <p class="user-name">{{ selectResponsavelName() }}</p>
            </div>
          </div>
        </div>
      </ion-header>

      <!-- Conteúdo do Menu -->
      <ion-content class="menu-content">
        <div class="menu-sections">

          <!-- Início (sempre presente) -->
          <div class="menu-section">
            <div class="section-label">{{ 'LESSOR.NAVIGATION.SECTION.START' | translate }}</div>
            <div class="menu-items">
              <ion-menu-toggle auto-hide="true">
                <div class="menu-item"
                     [class.active]="isActiveRoute('/home')"
                     (click)="redirectToHome()"
                     (keypress)="redirectToHome()">
                  <div class="item-content">
                    <div class="item-icon">
                      <ion-icon name="home-outline"></ion-icon>
                    </div>
                    <span class="item-label">{{ 'LESSOR.SIDE_MENU.HOME' | translate }}</span>
                  </div>
                  @if (isActiveRoute('/home')) {
                    <div class="active-indicator"></div>
                  }
                </div>
              </ion-menu-toggle>
            </div>
          </div>

          <!-- Seções dinâmicas -->
          @for (section of sideMenuSections(); track section.titleKey) {
            <div class="menu-section">
              <div class="section-label">{{ section.titleKey | translate }}</div>
              <div class="menu-items">
                @for (item of section.items; track item.id) {
                  <ion-menu-toggle auto-hide="true">
                    <div class="menu-item"
                         [class.disabled]="item.disabled"
                         [class.active]="isActiveRoute(item.link)"
                         (click)="redirectTo(item.link ?? '')"
                         (keypress)="redirectTo(item.link ?? '')">
                      <div class="item-content">
                        <div class="item-icon">
                          <img [src]="item.icon" [alt]="item.i18nKey | translate" />
                          @if (item.hasNotificationDot) {
                            <ion-badge color="tertiary" class="notification-dot"></ion-badge>
                          }
                        </div>
                        <span class="item-label">{{ item.i18nKey | translate }}</span>
                        @if (item.disabled) {
                          <ion-icon name="lock-closed-outline" class="item-lock"></ion-icon>
                        }
                      </div>
                      @if (isActiveRoute(item.link)) {
                        <div class="active-indicator"></div>
                      }
                    </div>
                  </ion-menu-toggle>
                }
              </div>
            </div>
          }

          <!-- Loja de módulos (CTA owner only) -->
          @if (storeCtaItem(); as cta) {
            <div class="menu-section">
              <div class="menu-items">
                <ion-menu-toggle auto-hide="true">
                  <div class="menu-item menu-item--cta"
                       (click)="redirectTo(cta.link ?? '')"
                       (keypress)="redirectTo(cta.link ?? '')">
                    <div class="item-content">
                      <div class="item-icon">
                        <ion-icon name="diamond-outline"></ion-icon>
                      </div>
                      <span class="item-label">{{ cta.i18nKey | translate }}</span>
                    </div>
                  </div>
                </ion-menu-toggle>
              </div>
            </div>
          }

        </div>
      </ion-content>

      <!-- Footer -->
      <ion-footer class="menu-footer">
        @if (isDevelopment()) {
          <div class="development-indicator">
            <ion-icon name="construct-outline"></ion-icon>
            <span>{{ environmentTitle() }}</span>
          </div>
        }

        <div class="footer-content">
          <div class="version-info">
            <span>versão {{ version }}</span>
          </div>

          <ion-button
            fill="clear"
            color="medium"
            class="logout-button"
            (click)="logout()"
            (keypress)="logout()">
            <ion-icon name="log-out-outline" slot="start"></ion-icon>
            <span>{{ 'LESSOR.SIDE_MENU.LOGOUT' | translate }}</span>
          </ion-button>
        </div>
      </ion-footer>

    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>

  </ion-split-pane>
</ion-app>
